// extracted by mini-css-extract-plugin
export var leftAlign = "_2w-2";
export var popper = "_2w-0";
export var subtitle = "_2w-1";